import { useNodes } from '@xyflow/react';
import { memo } from 'react';

import { NodeType } from '@/components/flow';

import { TriggerPanelSlideOut } from './TriggerPanelSlideOut.tsx';

export type TriggerPanelWrapperProps = {
  agentId: string;
};

const ITriggerPanelWrapper = ({ agentId }: TriggerPanelWrapperProps) => {
  const nodes = useNodes() as NodeType[];
  const selectedNode = nodes.find((node) => node.selected);
  const actionId = selectedNode?.data.resourceIds.find((r) => r.startsWith('cradl:action'));

  if (!actionId || !selectedNode || selectedNode.data.resourceGroupType !== 'trigger') {
    return null;
  }

  return <TriggerPanelSlideOut agentId={agentId} actionId={actionId} />;
};

export const TriggerPanelSlideOutWrapper = memo(ITriggerPanelWrapper) as typeof ITriggerPanelWrapper;
